import { cva } from 'class-variance-authority';

export const cardVariants = cva(
  'w-full flex flex-col gap-6 rounded-xl p-4 am-md:p-6 am-3xl:rounded-3xl',
  {
    variants: {
      variant: {
        primary: 'bg-white',
        secondary: 'bg-denim-100',
      },
      withoutBorder: {
        true: 'border-none',
        false: 'border',
      },
    },
    defaultVariants: {
      variant: 'primary',
      withoutBorder: false,
    },
    compoundVariants: [
      {
        variant: 'primary',
        withoutBorder: false,
        class: 'border border-teal-300',
      },
      {
        variant: 'secondary',
        withoutBorder: false,
        class: 'border border-denim-300',
      },
    ],
  }
);
